import { render, staticRenderFns } from "./AvisoSinistro.vue?vue&type=template&id=4c9acc18"
import script from "./AvisoSinistro.vue?vue&type=script&lang=js"
export * from "./AvisoSinistro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports